import { ManageDeviceProfileSelectors } from './manage-device-profile-selectors';
import { AuthenticationSelectors } from './authentication-selectors';
import { DashboardSelectors } from './dashboard-selectors';
import { LegalSelectors } from './legal-selectors';
import { NavigationSelectors } from './navigation-selectors';
import { RegistrationSelectors } from './registration-selectors';
import { UserSelectors } from './user-selectors';
import { TimelineExportSelectors } from './timeline-export-selectors';
import { SiganlRConnectionSelectors } from './siganlr-connection-selectors';
import { TrendExportSelectors } from './trend-export-selectors';
import { AlarmSelectors } from './alarm-selectors';
import { SiteSelectors } from './site-selectors';
import { SierraDeviceSelectors } from './device-selectors';
import { PxdbDeviceSelectors } from './pxdb-device-selectors';
//import { StarfishDeviceSelectors } from './pxdb-device-selectors';
import { StarfishDeviceSelectors } from './starfish-device-selectors ';
import { TrendChannelSelectors } from './trend-channel-selectors';
import { GetSubscriptionSelectors } from './get-subscription-selectors';
import { AlarmSuggestionSelectors } from './alarm-suggestion-selectors';
import { ResetUserSuggestionSelectors } from './reset-suggestion-selectors';
import { SensorDetailSelectors } from './sensor-detail-selectors';

import { GetOrgCheckSelectors } from './get-org-check-selector';
import { ManageAlarmsSelectors } from './manage-alarms-selectors';

export const Selectors = {
    Alarm: AlarmSelectors,
    Authentication: AuthenticationSelectors,
    Dashboard: DashboardSelectors,
    Legal: LegalSelectors,
    Navigation: NavigationSelectors,
    Registration: RegistrationSelectors,
    User: UserSelectors,
    TimelineExport: TimelineExportSelectors,
    SignalRConnection: SiganlRConnectionSelectors,
    TrendExport: TrendExportSelectors,
    Site: SiteSelectors,
    SierraDevice: SierraDeviceSelectors,
    StarfishDevice: StarfishDeviceSelectors,
    TrendChannels: TrendChannelSelectors,
    GetSubscription: GetSubscriptionSelectors,
    GetOrgCheck: GetOrgCheckSelectors,
    AlarmUserSuggestionSelector: AlarmSuggestionSelectors,
    ResetUserSuggestion: ResetUserSuggestionSelectors,
    SensorDetailSelectors: SensorDetailSelectors,
    PxdbDevice: PxdbDeviceSelectors,
    ManageAlarmsSelectors: ManageAlarmsSelectors,
    ManageDeviceProfileSelectors: ManageDeviceProfileSelectors,
};
